import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
import { trackAddToCart } from '../../utils/metaPixel';
interface CTAButtonProps {
  className?: string;
  text?: string;
  showIcon?: boolean;
}
const CHECKOUT_URL = 'https://www.nutricioncaninafacil.shop/cart/53464991138005:1?checkout';
export function CTAButton({
  className = '',
  text = 'QUIERO EMPEZAR HOY',
  showIcon = true
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    trackAddToCart();
    window.location.href = CHECKOUT_URL;
  };
  return <motion.a href={CHECKOUT_URL} onClick={handleClick} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.98
  }} className={`inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 text-lg md:text-xl font-bold text-white bg-primary rounded-full shadow-lg hover:bg-green-900 hover:shadow-glow transition-all duration-300 ${className}`} data-id="element-264">
      {showIcon && <ShoppingCartIcon className="w-6 h-6 mr-3" data-id="element-265" />}
      {text}
    </motion.a>;
}